import React, { useEffect, useState } from 'react';
import { supabase } from '../supabase';

export default function Substitutions() {
  const [subs, setSubs] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [editing, setEditing] = useState<any>(null);

  useEffect(() => { fetchSubs(); }, []);

  const fetchSubs = async () => {
    setLoading(true);
    const { data } = await supabase.from('substitutions').select('*').order('id', { ascending: false });
    if (data) setSubs(data);
    setLoading(false);
  };

  const deleteSub = async (id: number) => {
    if (!window.confirm('Удалить замену?')) return;
    await supabase.from('substitutions').delete().eq('id', id);
    fetchSubs();
  };

  const saveEdit = async () => {
    if (!editing) return;
    await supabase.from('substitutions').update({
      substitute_name: editing.substitute_name,
      ratio: editing.ratio,
      taste_note: editing.taste_note,
      priority: editing.priority,
    }).eq('id', editing.id);
    setEditing(null);
    fetchSubs();
  };

  const filtered = subs.filter(s =>
    s.original_ingredient_name?.toLowerCase().includes(search.toLowerCase()) ||
    s.substitute_name?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <h1 style={s.title}>🔄 Замены ингредиентов ({subs.length})</h1>

      <input style={{ ...s.search, marginBottom: 16 }} placeholder="Поиск..." value={search} onChange={e => setSearch(e.target.value)} />

      {editing && (
        <div style={s.editCard}>
          <h3 style={{ marginBottom: 16 }}>Редактировать замену</h3>
          <div style={s.editRow}>
            <div style={s.editField}>
              <label style={s.label}>Замена</label>
              <input style={s.input} value={editing.substitute_name} onChange={e => setEditing({ ...editing, substitute_name: e.target.value })} />
            </div>
            <div style={s.editField}>
              <label style={s.label}>Пропорция</label>
              <input style={s.input} value={editing.ratio} onChange={e => setEditing({ ...editing, ratio: e.target.value })} />
            </div>
            <div style={s.editField}>
              <label style={s.label}>Приоритет</label>
              <select style={s.input} value={editing.priority} onChange={e => setEditing({ ...editing, priority: parseInt(e.target.value) })}>
                <option value={0}>0 — Отлично</option>
                <option value={1}>1 — Хорошо</option>
                <option value={2}>2 — Допустимо</option>
                <option value={3}>3 — Нежелательно</option>
              </select>
            </div>
          </div>
          <div style={s.editField}>
            <label style={s.label}>Заметка о вкусе</label>
            <input style={s.input} value={editing.taste_note || ''} onChange={e => setEditing({ ...editing, taste_note: e.target.value })} />
          </div>
          <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
            <button style={s.btnSave} onClick={saveEdit}>💾 Сохранить</button>
            <button style={s.btnCancel} onClick={() => setEditing(null)}>Отмена</button>
          </div>
        </div>
      )}

      {loading ? <p>Загрузка...</p> : (
        <table style={s.table}>
          <thead>
            <tr style={s.thead}>
              <th style={s.th}>Оригинал</th>
              <th style={s.th}>Замена</th>
              <th style={s.th}>Пропорция</th>
              <th style={s.th}>Блюдо</th>
              <th style={s.th}>Источник</th>
              <th style={s.th}>Приоритет</th>
              <th style={s.th}>Действия</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(sub => (
              <tr key={sub.id} style={s.tr}>
                <td style={s.td}>{sub.original_ingredient_name}</td>
                <td style={s.td}>{sub.substitute_name}</td>
                <td style={s.td}>{sub.ratio}</td>
                <td style={s.td}>{sub.recipe_context || '—'}</td>
                <td style={s.td}>
                  <span style={{ ...s.badge, backgroundColor: sub.ai_generated ? '#eaf0fb' : '#d5f5e3', color: sub.ai_generated ? '#3498db' : '#2ECC71' }}>
                    {sub.ai_generated ? '🤖 ИИ' : '✅ Вручную'}
                  </span>
                </td>
                <td style={s.td}>{['Отлично', 'Хорошо', 'Допустимо', 'Нежелательно'][sub.priority] || sub.priority}</td>
                <td style={s.td}>
                  <button style={s.btnSmall} onClick={() => setEditing(sub)}>✏️ Изменить</button>
                  <button style={{ ...s.btnSmall, backgroundColor: '#e74c3c' }} onClick={() => deleteSub(sub.id)}>Удалить</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

const s: Record<string, React.CSSProperties> = {
  title: { fontSize: 24, fontWeight: 700, color: '#222', marginBottom: 24 },
  search: { padding: '10px 14px', borderRadius: 8, border: '1px solid #eee', fontSize: 14, width: 300, outline: 'none' },
  editCard: { backgroundColor: '#fff', borderRadius: 12, padding: 24, marginBottom: 16, boxShadow: '0 1px 4px rgba(0,0,0,0.06)', border: '2px solid #2ECC71' },
  editRow: { display: 'flex', gap: 16, marginBottom: 12 },
  editField: { flex: 1, display: 'flex', flexDirection: 'column', gap: 6 },
  label: { fontSize: 13, fontWeight: 600, color: '#555' },
  input: { padding: '10px 14px', borderRadius: 8, border: '1px solid #eee', fontSize: 14, outline: 'none' },
  btnSave: { padding: '10px 20px', backgroundColor: '#2ECC71', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 },
  btnCancel: { padding: '10px 20px', backgroundColor: '#f5f5f5', color: '#888', border: '1px solid #eee', borderRadius: 8, cursor: 'pointer' },
  table: { width: '100%', borderCollapse: 'collapse', backgroundColor: '#fff', borderRadius: 12, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' },
  thead: { backgroundColor: '#f9f9f9' },
  th: { padding: '12px 16px', textAlign: 'left', fontSize: 13, color: '#888', fontWeight: 600 },
  tr: { borderBottom: '1px solid #f0f0f0' },
  td: { padding: '12px 16px', fontSize: 14, color: '#222' },
  badge: { padding: '4px 10px', borderRadius: 20, fontSize: 12, fontWeight: 500 },
  btnSmall: { padding: '6px 12px', backgroundColor: '#2ECC71', color: '#fff', border: 'none', borderRadius: 6, fontSize: 12, cursor: 'pointer', marginRight: 6 },
};